import { ChangeDetectionStrategy, Component, signal, input, effect, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Video } from '../../models/product.model';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

interface VideoWithSafeUrl extends Omit<Video, 'url'> {
  url: SafeResourceUrl;
}

@Component({
  standalone: true,
  selector: 'base-videos',
  templateUrl: './videos.component.html',
  styleUrls: ['./videos.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule]
})
export class VideosComponent {
  private domSanitizer = inject(DomSanitizer);

  

  readonly videosInput = input<Video[] | undefined>(undefined);
  
  private _videos = signal<VideoWithSafeUrl[]>([]);
  readonly videos = this._videos.asReadonly();

  constructor() {
    effect(() => {
      const videosValue = this.videosInput();
      if (videosValue && videosValue.length > 0) {
        const processedVideos = videosValue.map(video => ({
          ...video,
          url: this.domSanitizer.bypassSecurityTrustResourceUrl(video.url || '')
        }));
        this._videos.set(processedVideos);
      } else {
        this._videos.set([]);
      }
    });
  }
}

